import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { getUserActiveAgents, type AIAgent } from "@/lib/services/agents";

export function useAgentAccess() {
  const { user } = useAuth();
  const [agents, setAgents] = useState<AIAgent[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadAgents() {
      if (!user?.id) return;

      try {
        setIsLoading(true);
        setError(null);
        const activeAgents = await getUserActiveAgents(user.id);
        setAgents(activeAgents);
      } catch (err) {
        setError(err instanceof Error ? err.message : "Failed to load agents");
      } finally {
        setIsLoading(false);
      }
    }

    loadAgents();
  }, [user?.id]);

  return { agents, isLoading, error };
}
